import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { 
  BasedOnMedicareEditor,
  PercentOfMedicareIPEditor,
  PercentOfMedicareOPEditor,
  InpatientConversionFactorEditor,
  OutpatientConversionFactorEditor,
  MedicareContractIdEditor
} from '../../fieldEditors/contractEditors';

const MedicareBasedConfigSection: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Medicare Based Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure Medicare-based settings and rules for this contract.
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <BasedOnMedicareEditor />

        {/* Percent of Medicare + Conversion Factors — all 4 on one row */}
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { md: 'flex-start' },
          gap: 2
        }}>
          {/* % of Medicare group */}
          <Box sx={{ flex: '1 1 0%', minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', textAlign: 'center', fontWeight: 600 }}>
              % of Medicare
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ flex: 1, minWidth: 0 }}><PercentOfMedicareIPEditor /></Box>
              <Box sx={{ flex: 1, minWidth: 0 }}><PercentOfMedicareOPEditor /></Box>
            </Box>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: 'none', md: 'block' }, borderColor: 'divider' }}
          />
          <Divider
            sx={{ display: { xs: 'block', md: 'none' } }}
          />

          {/* Conversion Factor group */}
          <Box sx={{ flex: '1 1 0%', minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', textAlign: 'center', fontWeight: 600 }}>
              Conversion Factors
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ flex: 1, minWidth: 0 }}><InpatientConversionFactorEditor /></Box>
              <Box sx={{ flex: 1, minWidth: 0 }}><OutpatientConversionFactorEditor /></Box>
            </Box>
          </Box>
        </Box>

        <MedicareContractIdEditor />
      </Box>
    </SectionPaper>
  );
};

export default MedicareBasedConfigSection;